import { useContext } from "react";

import Context from "../../context";
import InputSelector from "./InputSelector";
import RadioSelector from "./RadioSelector";

// ----------------------------------------------------------------------

type Props = {
	onChangeSelect: (value: string) => void;
	selectedValue: string;
};

export const RowSelector = ({ onChangeSelect, selectedValue }: Props) => {
	const { params } = useContext(Context);
	const isSelector = !!params.find((field) => field.type === "select");

	return isSelector ? (
		<InputSelector onChangeSelect={onChangeSelect} selectedValue={selectedValue} />
	) : (
		<RadioSelector onChangeSelect={onChangeSelect} selectedValue={selectedValue} />
	);
};

export default RowSelector;
